import { cn as e } from "../../cn.js";
import { getStyles as t } from "./style.js";
import { FormErrorText as n, FormHelperText as r, FormLabel as i } from "../shared/form-primitives.js";
import { forwardRef as a } from "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { Field as c } from "@ark-ui/react";
// src/design/forms/text-area/index.tsx
var l = a(({ label: a, helperText: l, errorText: u, required: d = !1, invalid: f = !1, disabled: p = !1, readOnly: m = !1, showCharacterCount: h = !1, maxLength: g, config: _, className: v, value: y, ...b }, x) => {
	let S = t(_), C = !!u || f, w = typeof y == "string" ? y.length : 0, T = g ? w >= g : !1, E = y === void 0 ? b : {
		value: y,
		...b
	};
	return /* @__PURE__ */ s(c.Root, {
		className: S.root({ disabled: p }),
		invalid: C,
		required: d,
		disabled: p,
		readOnly: m,
		children: [
			a && /* @__PURE__ */ o(i, {
				required: d,
				disabled: p,
				children: a
			}),
			/* @__PURE__ */ o(c.Textarea, {
				className: e(S.textarea(), v),
				maxLength: g,
				ref: x,
				...E
			}),
			(l || u || h && y !== void 0) && /* @__PURE__ */ s("div", {
				className: "flex items-center justify-between gap-2",
				children: [/* @__PURE__ */ s("div", {
					className: "flex-1",
					children: [u && /* @__PURE__ */ o(n, { children: u }), l && !u && /* @__PURE__ */ o(r, { children: l })]
				}), h && y !== void 0 && /* @__PURE__ */ s("div", {
					className: S.characterCount(T),
					children: [w, g && `/${g}`]
				})]
			})
		]
	});
});
l.displayName = "TextArea";
var u = ({ children: n, className: r, ...i }) => {
	let a = t();
	return /* @__PURE__ */ o(c.Root, {
		className: e(a.root({ disabled: i.disabled }), r),
		...i,
		children: n
	});
}, d = ({ children: e, className: t, required: n, ...r }) => /* @__PURE__ */ o(i, {
	className: t,
	required: n,
	...r,
	children: e
}), f = a(({ className: n, config: r, ...i }, a) => {
	let s = t(r);
	return /* @__PURE__ */ o(c.Textarea, {
		ref: a,
		className: e(s.textarea(), n),
		...i
	});
});
f.displayName = "Textarea";
var p = Object.assign(l, {
	Root: u,
	Label: d,
	Textarea: f,
	HelperText: ({ children: e, className: t, ...n }) => /* @__PURE__ */ o(r, {
		className: t,
		...n,
		children: e
	}),
	ErrorText: ({ children: e, className: t, ...r }) => /* @__PURE__ */ o(n, {
		className: t,
		...r,
		children: e
	}),
	RequiredIndicator: ({ children: n, className: r, ...i }) => {
		let a = t();
		return /* @__PURE__ */ o(c.RequiredIndicator, {
			className: e(a.requiredIndicator(), r),
			...i,
			children: n ?? "*"
		});
	},
	getStyles: t
});
export { p as TextArea };

//# sourceMappingURL=index.js.map